import HowToVoteOutlinedIcon from '@mui/icons-material/HowToVoteOutlined';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import BackupOutlinedIcon from '@mui/icons-material/BackupOutlined';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import ConstructionOutlinedIcon from '@mui/icons-material/ConstructionOutlined';
import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined';
import ChildCareOutlinedIcon from '@mui/icons-material/ChildCareOutlined';
import FamilyRestroomOutlinedIcon from '@mui/icons-material/FamilyRestroomOutlined';
import DirectionsCarOutlinedIcon from '@mui/icons-material/DirectionsCarOutlined';
import FolderOpenOutlinedIcon from '@mui/icons-material/FolderOpenOutlined';
import GavelOutlinedIcon from '@mui/icons-material/GavelOutlined';
import HandymanOutlinedIcon from '@mui/icons-material/HandymanOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import RocketLaunchOutlinedIcon from '@mui/icons-material/RocketLaunchOutlined';
import MapOutlinedIcon from '@mui/icons-material/MapOutlined';
import ParkOutlinedIcon from '@mui/icons-material/ParkOutlined';
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import PercentOutlinedIcon from '@mui/icons-material/PercentOutlined';
import QuestionAnswerOutlinedIcon from '@mui/icons-material/QuestionAnswerOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import SecurityOutlinedIcon from '@mui/icons-material/SecurityOutlined';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import WorkOutlinedIcon from '@mui/icons-material/WorkOutlined';

import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';

import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';

// ----------------------------------------------------------------------

/**
 * Ikonerna som sidebaren använder. En ikon per toppnivåmeny — undermenyer är
 * avsiktligt ikonlösa, annars blir listan brusig.
 */
export const ICONS = {
  demo: <AutoAwesomeOutlinedIcon />,
  hem: <HomeOutlinedIcon />,
  komIgång: <RocketLaunchOutlinedIcon />,
  meddelanden: <QuestionAnswerOutlinedIcon />,
  ärenden: <ConfirmationNumberOutlinedIcon />,
  dokument: <FolderOpenOutlinedIcon />,

  bokaLåna: <HandymanOutlinedIcon />,
  fordon: <DirectionsCarOutlinedIcon />,
  karta: <MapOutlinedIcon />,

  förening: <BusinessOutlinedIcon />,
  styrelse: <GavelOutlinedIcon />,
  utskick: <SendOutlinedIcon />,
  medlemmar: <PeopleOutlinedIcon />,
  fastighet: <ApartmentOutlinedIcon />,
  projekt: <ConstructionOutlinedIcon />,

  ekonomi: <AccountBalanceOutlinedIcon />,
  fastighetslån: <AccountBalanceWalletOutlinedIcon />,
  bokföring: <ReceiptLongOutlinedIcon />,
  rapporter: <AssessmentOutlinedIcon />,
  fakturor: <ReceiptOutlinedIcon />,
  lön: <PaymentsOutlinedIcon />,
  minAnställning: <BadgeOutlinedIcon />,
  tidOchFrånvaro: <AccessTimeOutlinedIcon />,
  förskola: <ChildCareOutlinedIcon />,
  minaBarn: <FamilyRestroomOutlinedIcon />,
  skattLöner: <PercentOutlinedIcon />,
  försäkringar: <SecurityOutlinedIcon />,

  kunder: <StorefrontOutlinedIcon />,
  konsult: <WorkOutlinedIcon />,
  arborist: <ParkOutlinedIcon />,

  offentlighet: <MenuBookOutlinedIcon />,
  revision: <FactCheckOutlinedIcon />,
  juridik: <GavelOutlinedIcon />,

  omröstning: <HowToVoteOutlinedIcon />,

  inställningar: <SettingsOutlinedIcon />,
  system: <AdminPanelSettingsOutlinedIcon />,
  backup: <BackupOutlinedIcon />,
};
